import React from 'react'
import {backgroundDark,backgroundLight} from "../assets/images"
import { useStateContext } from '../context/ContextProvider'
import { Counter, Footer, Header, Map } from '../components/layout'
import { C_Blogs, C_Hero, C_Section2 } from '../components/Charities'
const Charities = () => {
  const {currentMode}=useStateContext()
  const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
  return (
    <div className='w-full'
    style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <Header active={"/"} />
      <C_Hero />
      <Counter />
      <C_Section2 />
      <C_Blogs />

      <Footer />
      </div>
  )
}

export default Charities